import {Component, Directive, Output, Input, EventEmitter} from '@angular/core';
import {CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import {Params, Router, ActivatedRoute} from '@angular/router';
import {MainService} from '../main.service';

@Component({
    selector: 'forgetPassword',    
    providers: [MainService],
    template: require('./change-password.component.html'),
})

export class MainChangePasswordComponent {

    router: Router;
    emailKey: string;
    password1: string;
    password2: string;
    code: number;

    constructor(private _mainService: MainService, private route: ActivatedRoute, private _parentRouter: Router) {
        this.emailKey = route.snapshot.params['emailKey'];
        this.password1 = "";
        this.password2 = "";
        this.code = -1;
        this.router = _parentRouter;
    }    

    changePassword() {        
        if(!this.isNullOrEmpty(this.password1) && !this.isNullOrEmpty(this.password2)) {

            if(this.password1.length >= 5 && this.password2.length >= 5) {
                if(this.password1 == this.password2) {
                    this.code = -1;
                    this._mainService.changeUserPassword(this.emailKey, this.password1).then(res => {
                        if(res != null && res.code == 1) {
                            localStorage.setItem('userName', res.user_name);                
                            localStorage.setItem('idUser', res.user_id.toString());
                            localStorage.setItem('token', res.user_token);
                            this.router.navigate(['/main', 'dashboard']);
                        }
                    });
                } else {
                    this.code = 7;
                }
            } else if(this.password1.length < 5 && this.password2.length >= 5) {
                this.code = 4;
            } else if(this.password1.length >= 5 && this.password2.length < 5) {
                this.code = 5;
            } else {
                this.code = 6;
            }

        } else if(this.isNullOrEmpty(this.password1) && !this.isNullOrEmpty(this.password2)) {
            this.code = 1;
        } else if(!this.isNullOrEmpty(this.password1) && this.isNullOrEmpty(this.password2)) {
            this.code = 2;
        } else {            
            this.code = 3;
        }        
    }

    isNullOrEmpty(text: string) {
        if(text == null || text == undefined || text == "") {
            return true;
        } else {
            return false;
        }
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/change_password/change-password.component.ts
 **/